import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.article`
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(3)}`};

  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.spacing(3)};
  background: ${({ theme }) => theme.palette.backgroundExtended.card};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Data = styled.div``;

export const Value = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.h5)};
`;

export const Target = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  padding-left: ${({ theme }) => theme.spacing(1)};

  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const Body = styled.div`
  display: flex;
  color: ${({ theme }) => theme.palette.text.secondary};
  min-width: 0;
`;

export const Description = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  color: ${({ theme }) => theme.palette.grey[600]};
`;
